import React, { Component, lazy, Suspense } from 'react'
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import CustomerList from '../CustomerList'
import RecentChatList from './recentChatList.js'
import CurrentChatList from '../CurrentChatList'
import t from '../../localization'
import { connect } from 'react-redux'
import { reportPreviewActions, report } from '../../../client/lossAss/actions'
import { bindActionCreators } from 'redux'
import { Tabs, message, Upload, Input, Button } from 'antd';
import dayjs from 'dayjs'
import { getChatMsg, getChatMsgDetail, getRecentCall } from '../../service/report';
import { leaveMessage } from '../../service/common';
import NoData from '../../components/NoData';
import './style.scss'
import './chat.scss'
import './main.scss'

const MessageComp = lazy(() => import('../MessageComp'));

const { TabPane } = Tabs, { TextArea } = Input;

const pageSize = 20;

const typeMap = (type) => {
    if (type === 'text') {
        return 'text'
    }
    if (['jpg', 'png', 'bmp', 'JPG', "PNG", "BMP", "jpeg"].includes(type)) {
        return 'photo'
    }

    if (['zip', 'rar', 'pdf', 'xlsx', 'docx', 'mp4', 'avi', 'mov', '3gp', 'mpeg', 'rm',
        'ZIP', "RAR", "PDF", "XLSX", "DOCX", "MP4", "AVI", 'MOV', "3GP", 'MPEG', "RM",

    ].includes(type)) {
        return 'file'
    }

}


const getFileName = (fileUrl) => {
    const pos = fileUrl.lastIndexOf('/');//'/所在的最后位置'
    const str = fileUrl.substr(pos + 1)//截取文件名称字符串
    return str
}
const isImage = ['jpg', 'jpeg', 'png', 'gif'];

class CustomerSidebar extends Component {
    state = {
        chatType: 'newSession',
        isShowChatContainer: false,
        result: {},
        record: {},
        messageList: [],
        messageText: '',
        msgs: [],
        isImage: false,
        formData: {},
        currentPage: 1,
        total: 0,
        chatInfo: {},
        recentCall: [],
        recentCallTotal: 0,
        recentCallCurrentPage: 1,
        unreadCount: 0
    }
    msgRef = React.createRef();
    recentRef = React.createRef();
    messageRef = React.createRef();

    isAjax = false;
    componentDidMount() {
        this.getMsgs();
        this.getRecentCallList();
        window.addEventListener("paste", this.handlePaste);
    }
    componentWillUnmount() {
        window.removeEventListener("paste", this.handlePaste);
    }
    componentDidUpdate(prevProps) {
        if (this.props.chatInfo.chatCollapsed !== prevProps.chatInfo.chatCollapsed) {
            this.setState({
                isShowChatContainer: false
            })
        }
    }
    getRecentCallList(isMerge = false) {
        getRecentCall(this.props.currentAgent._id, {
            pageSize,
            pageIndex: this.state.recentCallCurrentPage
        }).then(({ result }) => {
            this.isAjax = false;
            this.setState({
                recentCall: isMerge ? [...this.state.recentCall, ...result.result] : result.result,
                recentCallTotal: result.recentCount
            });
        }).catch(() => {
            this.isAjax = false;
        })
    }
    // 刷新会话列表，需重新拉取已有分页的数据
    refreshRecentMsg = () => {
        const { recentCallCurrentPage } = this.state;
        getRecentCall(this.props.currentAgent._id, {
            pageSize: recentCallCurrentPage * pageSize,
            pageIndex: 1
        }).then(({ result }) => {
            this.setState({
                recentCall: result.result,
                recentCallTotal: result.recentCount
            });
        });
    }
    // 切换会话和消息
    callback = (key) => {
        const { isShowChatContainer } = this.state;
        if (isShowChatContainer) {
            this.setState({
                isShowChatContainer: false
            })
        }
        // 切到到消息，重新刷新列表
        if (key === 'msg') {
            this.refreshChat();
        }
    }
    // 切换会话类型
    changeChatType(type) {
        this.setState({
            chatType: type
        })
        if (type === 'recentSession') {
            this.refreshRecentMsg();
        }
    }

    // 刷新会话列表，需重新拉取已有分页的数据
    refreshChat = () => {
        const { currentPage } = this.state;
        getChatMsg({
            pageSize: currentPage * pageSize,
            pageIndex: 1
        }).then(({ result }) => {
            this.setState({
                total: result.count,
                msgs: result.msgs,
                unreadCount: result.unreadCount
            })
            this.props.actions.updateChatCount({
                chatCount: result.unreadCount + this.props.serviceRequests.length
            });

        }).catch(err => {
            message.error(err.message || '请求/api/report/msgboards失败')
        })
    }
    // 点击消息
    handleChatItemClick = (record) => {
        this.setState({
            isShowChatContainer: true,
            record
        }, async () => {
           await this.getMessageList(record);
           await this.refreshChat();
        })
    }
    // 关闭查看消息
    handleClose = () => {
        this.setState({
            isShowChatContainer: false,
            record: {}
        })
    }
    // 查看案件详情
    viewReportDetails = async (e, record) => {
        const { actions } = this.props;
        e.stopPropagation()
        this.handleClose()


        actions.getCreateReport('update')
        actions.changeActiveReportTab('1')
        actions.getCurrentReport(record.flowId)

        this.props.history.push(`/workBench/ReportDetail/${record.flowId}`);
    }
    // 获取消息列表
    getMsgs = (isMerge = false) => {
        getChatMsg({
            pageSize,
            pageIndex: this.state.currentPage
        }).then(({ result }) => {
            this.isAjax = false;
            const list = isMerge ? [...this.state.msgs, ...result.msgs] : result.msgs;
            this.setState({
                total: result.count,
                msgs: list,
                unreadCount: result.unreadCount
            })
            this.props.actions.updateChatCount({
                chatCount: result.unreadCount + this.props.serviceRequests.length
            });
        }).catch(err => {
            this.isAjax = false;
            message.error(err.message || '请求/api/report/msgboards失败')
        })
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { serviceRequests: nextServiceRequests, hasNewMsg: nextHasNewMsg } = nextProps, { serviceRequests, hasNewMsg } = this.props;

        if (nextServiceRequests !== serviceRequests) {
            this.props.actions.updateChatCount({
                chatCount: this.state.unreadCount + nextServiceRequests.length
            });
        }
        // socket通知有新消息，则刷新消息列表，并将新消息设置为false
        if (nextHasNewMsg !== hasNewMsg && nextHasNewMsg) {
            this.refreshChat();
            this.props.actions.updateMsgBoard({
                agentGotNewMsg: false
            })
        }
    }

    handlePaste = (event) => {

        var items = (event.clipboardData || window.clipboardData).items;
        var file = null;
        if (items && items.length) {
            // 搜索剪切板items
            for (var i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image') !== -1) {
                    file = items[i].getAsFile();
                    break;
                }
            }
        } else {
            message.info('当前浏览器不支持')
            return;
        }
        if (!file) {
            // message.info('粘贴内容非图片')
            return;
        }
        var formData = new FormData();// 创建form对象
        formData.append('file', file);
        formData.append('flowId', this.state.record.flowId);
        formData.append('agentName', this.props.currentAgent.fullName);
        formData.append('agentId', this.props.currentAgent._id);
        this.setState({
            messageText: "【图片】",
            formData,
            isImage: true
        })
    }

    getMessageList = (record) => {
        return new Promise(resolve => {
            getChatMsgDetail({
                flowId: record.flowId,
                role: 1,
                agentId: this.props.currentAgent._id,
            }).then(({ result }) => {
                // 转换数据
                const messageList = result.msgBoard.map(item => {
                    return {
                        className: item.role === 2 ? '' : 'message-right',
                        position: item.role === 2 ? 'left' : 'right',
                        type: typeMap(item.contentType),
                        text: item.contentType === 'text' ? item.text : (getFileName(item.url).length > 10 ? getFileName(item.url).slice(- 14) : getFileName(item.url)),
                        // date: new Date(),
                        data: item.contentType !== 'text' ? {
                            uri: item.url,
                            status: typeMap(item.contentType) === 'file' ? {
                                click: false,
                                loading: 0,
                            } : undefined
                        } : undefined,
                        title: item.role === 2 ? '客户' + dayjs(item.time).format("YYYY-MM-DD HH:mm:ss") : item.sender + ' ' + dayjs(item.time).format("YYYY-MM-DD HH:mm:ss")
                    }
                })
                this.setState({
                    messageList: messageList,
                    chatInfo: result
                }, () => {
                    resolve();
                    if (this.messageRef.current) {
                        this.messageRef.current.scrollTop = this.messageRef.current.scrollHeight
                    }
                })
            }).catch(err => {
                message.error(err.message || '请求/report/msgboard失败')
            })
        })

    }
    handleChangeMessageText = (e) => {
        this.setState({
            messageText: e.target.value
        })
        if (e.target.value === '') {
            this.setState({
                isImage: false
            })
        }
    }
    send = () => {
        const { isImage, formData } = this.state
        if (isImage) {
            this.state.record.flowId && leaveMessage(formData, { 'Content-Type': 'multipart/form-data' }).then(() => {
                this.setState({
                    messageText: '',
                    isImage: false,
                    formData: {}
                })
                message.success('操作成功')
                setTimeout(() => {
                    this.getMessageList(this.state.record)
                }, 1000);
            }).catch(err => {
                message.error(err.message || '请求/api/lossAss/report/agent/leaveMessage失败')
            })
            return
        }
        leaveMessage({
            flowId: this.state.record.flowId,
            message: this.state.messageText,
            // 增加参数
            agentName: this.props.currentAgent.fullName,
            agentId: this.props.currentAgent._id,

        }).then(() => {
            this.setState({
                messageText: ''
            })
            message.success('操作成功')
            setTimeout(() => {
                this.getMessageList(this.state.record)
            }, 1000);
        }).catch(err => {
            message.error(err.message || '请求/api/lossAss/report/agent/leaveMessage失败')
        })
    }
    // 加载更多消息
    loadMore = () => {
        this.setState({
            currentPage: this.state.currentPage + 1
        }, () => {
            this.getMsgs(true)
        })
    }
    // 加载更多会话
    loadMoreRecentCall = () => {
        this.setState({
            recentCallCurrentPage: this.state.recentCallCurrentPage + 1
        }, () => {
            this.getRecentCallList(true)
        })
    }
    handleScroll = () => {
        const { currentPage, total } = this.state;
        const clientHeight = this.msgRef.current.clientHeight,
            scrollTop = this.msgRef.current.scrollTop,
            scrollHeight = this.msgRef.current.scrollHeight;
        //如果滚动到底部
        if (scrollHeight - clientHeight - scrollTop < 20) {
            if (currentPage < Math.ceil(total / pageSize) && !this.isAjax) {
                this.isAjax = true;
                this.loadMore();
            }
        }
    }
    handleScrollByRecent = () => {
        const { recentCallCurrentPage, recentCallTotal } = this.state;
        const clientHeight = this.recentRef.current.clientHeight,
            scrollTop = this.recentRef.current.scrollTop,
            scrollHeight = this.recentRef.current.scrollHeight;
        //如果滚动到底部
        if (scrollHeight - clientHeight - scrollTop < 20) {
            if (recentCallCurrentPage < Math.ceil(recentCallTotal / pageSize) && !this.isAjax) {
                this.isAjax = true;
                this.loadMoreRecentCall();
            }
        }
    }
    handleUpload = options => {
        const { file, onSuccess } = options;
        var formData = new FormData();// 创建form对象
        formData.append('file', file);
        formData.append('flowId', this.state.record.flowId);
        formData.append('agentName', this.props.currentAgent.fullName);
        formData.append('agentId', this.props.currentAgent._id);

        leaveMessage(formData).then(() => {
            message.success(`${file.name} 上传成功`);
            this.getMessageList(this.state.record);
            onSuccess && onSuccess();
        })
    }
    render() {
        const {
            actions,
            currentAgent,
            serviceRequests,
            handleClickCustomer,
            handleCancelServiceRequest,
            customers,
            dashboard
        } = this.props;

        let videoChatRequests = serviceRequests


        const { isShowChatContainer, chatType, messageList, msgs, total, chatInfo, recentCall, recentCallTotal, unreadCount } = this.state

        return (
            <div className="customer-sidebar">
                <Tabs defaultActiveKey="conversation" size="small" onChange={this.callback} style={{ height: '100%' }} destroyInactiveTabPane={true}>
                    <TabPane tab={<React.Fragment>会话 {videoChatRequests.length}</React.Fragment>} key="chat">
                        {/* {
                            videoChatRequests && videoChatRequests.length ? <span className="circleMsgs"></span> : null
                        } */}
                        <ul className="customer-infos">
                            <li className={chatType == 'newSession' ? 'current' : ''} onClick={this.changeChatType.bind(this, 'newSession')}>
                                会话请求
                            </li>
                            <li className={chatType == 'currentSession' ? 'current' : ''} onClick={this.changeChatType.bind(this, 'currentSession')}>
                                会话中
                            </li>
                            <li className={chatType == 'recentSession' ? 'current' : ''} onClick={this.changeChatType.bind(this, 'recentSession')}>
                                最近会话
                            </li>
                        </ul>
                        {
                            chatType == 'newSession' ? <React.Fragment>
                                <CustomerList
                                    title={t('CustomerSidebar::videoChatRequests')}
                                    icon={'videos1'}
                                    currentAgent={currentAgent}
                                    customers={videoChatRequests}
                                    currentSession={customers}
                                    handleClickCustomer={handleClickCustomer}
                                    handleCancelServiceRequest={handleCancelServiceRequest}
                                    actions={actions}
                                    dashboard={dashboard} />
                                {/* <div className="customer-rep-name">
                                        {videoChatCustomerList}
                                    </div> */}
                            </React.Fragment> : chatType == 'currentSession' ? <CurrentChatList
                                title={t('CustomerSidebar::openSessions')}
                                icon={'openSession'}
                                customers={customers}
                                actions={actions}
                                dashboard={dashboard}
                            /> : <div className='open-chat-list' onScroll={this.handleScrollByRecent} ref={this.recentRef}>
                                {
                                    recentCall.length ? <React.Fragment>
                                        <RecentChatList
                                            title={t('CustomerSidebar::recentSessions')}
                                            icon={'latelySession1'}
                                            list={recentCall}
                                            currentAgent={currentAgent}
                                            actions={actions}
                                            dashboard={dashboard} />
                                        {
                                            recentCallTotal > 0 && recentCallTotal !== recentCall.length ? <div style={{ textAlign: 'center' }}>
                                                <Button className="load-more" type="link">加载更多...</Button>
                                            </div> : null
                                        }
                                    </React.Fragment> : <NoData />
                                }

                            </div>
                        }
                    </TabPane>

                    <TabPane tab={<React.Fragment>
                        消息 {unreadCount > 99 ? '99+' : unreadCount}
                    </React.Fragment>} key="msg">
                        <div className='chat-list' onScroll={this.handleScroll} ref={this.msgRef}>
                            {
                                msgs.length ? <React.Fragment>
                                    <ul className='list' id='scroll-list'>
                                        {
                                            msgs.map(item => <li
                                                className={`list-item ${item.msgWaitingCheck === 1 ? 'unread' : ''} ${item._id === this.state.record._id ? 'current' : ''}`}
                                                onClick={() => this.handleChatItemClick(item)}
                                                key={item._id}
                                            >
                                                <h4>
                                                    <span className="name">{item.carOwner}</span>
                                                    <span className="number">{item.flowId}</span>
                                                </h4>
                                                <p>{isImage.includes(item.msgLatest.contentType.toLowerCase()) ? '【图片消息】' : item.msgLatest.contentType === 'file' ? '【文本消息】' : item.msgLatest.text}</p>
                                                <p className="time">{dayjs(item.msgLatest.time).format("MM-DD HH:mm:ss")}</p>
                                            </li>
                                            )
                                        }
                                    </ul>
                                    {
                                        total > 0 && total !== msgs.length ? <div style={{ textAlign: 'center' }}><Button className="load-more" type="link">加载更多...</Button></div> : null
                                    }
                                </React.Fragment> : <NoData />
                            }
                            {
                                isShowChatContainer ? <div className='chat-container-modal' style={{ maxHeight: parseInt(window.innerHeight * 0.9)}}>
                                    <i className="iconfont icon-close" onClick={this.handleClose} />
                                    <div className='report-info'>
                                        <p>报案时间:{dayjs(chatInfo.ctime).format("YYYY-MM-DD HH:mm:ss")}  <a onClick={(e) => this.viewReportDetails(e, this.state.record)}>案件详情</a></p>
                                        <p><span>工单状态：{chatInfo.stateText}</span><span> 定损状态：{chatInfo.lossStateText}</span></p>
                                    </div>
                                    <div className="chat-container-msg" ref={this.messageRef}>
                                        <Suspense fallback={<div style={{ textAlign: 'center', margin: 20 }}>加载中...</div>}>
                                            <MessageComp list={messageList} />
                                        </Suspense>
                                    </div>
                                    <div className="chat-container-btns">
                                        <div style={{ background: '#EBEBEB', display: 'flex', padding: '0 10px', alignItems: 'center' }}>
                                            <Upload showUploadList={false} accept='.jpg,.png,.bmp' customRequest={this.handleUpload}>
                                                <i className="iconfont icon-picture" style={{ fontSize: 20,  }} />
                                            </Upload>
                                            <Upload showUploadList={false} accept='.zip,.rar,.pdf,.xlsx,.docx,video/*' customRequest={this.handleUpload}>
                                                <i className="iconfont icon-folder-outlined" style={{ fontSize: 20 }} />
                                            </Upload>
                                        </div>
                                        <TextArea value={this.state.messageText} onChange={this.handleChangeMessageText} placeholder='点击快捷回复' className="chat-container-textarea" />
                                        <Button disabled={!this.state.messageText} onClick={this.send} type="primary" shape="round" size="small" className="chat-container-send">发送</Button>
                                    </div>

                                </div> : null
                            }
                        </div>

                    </TabPane>
                </Tabs>
            </div>
        )
    }
}

/**
 * Props that CustomerSidebar component expects to be passed.
 */
CustomerSidebar.propTypes = {
    actions: PropTypes.objectOf(PropTypes.func).isRequired,
    handleClickCustomer: PropTypes.func.isRequired,
    // Bool of whether the agent is in a call.
    isWithCall: PropTypes.bool,
    // Array of customers.
    serviceRequests: PropTypes.array,
    actions: PropTypes.object,
}

/**
 * Default props when CustomerSidebar isn't passed any prop.
 */
CustomerSidebar.defaultProps = {
    isWithCall: false,
    serviceRequests: [],
    actions: {}
}

let mapStateToProps = (state) => {
    return {
        chatInfo: state.app.chatHistory
    }
};
let mapDispatchToProps = (dispatch) => {
    return {
        reportPreviewActions: bindActionCreators(Object.assign({},
            reportPreviewActions,
            report
        ), dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(CustomerSidebar))

// export default CustomerSidebar
